import React, { useEffect, useState } from "react";
import DefaultView from "../components/DefaultView";
import { actionGetFaxQueues } from "../store/actions/sentFaxesAction";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import EmptyResult from "../components/EmptyResult";

const Queues = ({ queuesDataLoader, queuesData, actionGetFaxQueues, user }) => {
  const { type } = useParams();
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedQueue, setSelectedQueue] = useState(null);

  useEffect(() => {
    user && actionGetFaxQueues(user.user_ID, type);
  }, [user, type]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleRefresh = () => {
    user && actionGetFaxQueues(user.user_ID, type);
  };

  const filteredData = queuesData.filter((queue) => {
    const values = {
      ...queue,
      msg_requestTime: moment(queue.msg_requestTime).format(
        "DD MMM YYYY, hh:mm A"
      ),
      update_time: moment(queue.update_time).format("DD MMM YYYY, hh:mm A"),
    };

    return Object.values(values)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase());
  });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 main_heading">
                {type === "IN" ? "Incoming" : "Outgoing"} Queues
              </h4>
              <div className="page-title-right">
                <DefaultView />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <h4 className="card-title mb-1">
                    {type === "IN" ? "Incoming" : "Outgoing"}
                  </h4>
                  <p className="card-title-desc mb-0">
                    {type === "IN" ? "Incoming" : "Outgoing"} fax queues will be
                    listed here.
                  </p>
                </div>

                <div
                  className="d-flex align-items-center gap-2"
                  style={{ minWidth: "300px" }}
                >
                  <input
                    type="text"
                    className="form-control py-2 form-control-sm"
                    placeholder="Search..."
                    value={search}
                    onChange={handleSearch}
                  />
                  <button
                    className="btn btn-outline-success btn-sm"
                    onClick={handleRefresh}
                    type="button"
                  >
                    <i className="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  {queuesDataLoader ? (
                    <table className="table table-striped promo-table mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Status</th>
                          <th>Request Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(5)].map((_, i) => (
                          <tr key={i}>
                            {[
                              "60px",
                              "140px",
                              "140px",
                              "100px",
                              "160px",
                              "100px",
                            ].map((width, j) => (
                              <td key={j}>
                                <div
                                  className="skeleton py-2"
                                  style={{ width: width, height: 16 }}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : filteredData.length > 0 ? (
                    <table className="table table-striped promo-table mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Status</th>
                          <th>Request Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((queueData, index) => (
                          <tr key={index}>
                            <td className="ellipsis" title={index + 1}>
                              {index + 1}
                            </td>

                            <td
                              className="ellipsis"
                              title={queueData.msg_fromNumber}
                            >
                              {queueData.msg_fromNumber}
                            </td>

                            <td
                              className="ellipsis"
                              title={queueData.msg_toNumber}
                            >
                              {queueData.msg_toNumber}
                            </td>

                            <td
                              className="ellipsis"
                              title={queueData.fax_status}
                            >
                              <span
                                style={{
                                  color:
                                    queueData.fax_status === "SUCCESS"
                                      ? "green"
                                      : queueData.fax_status === "FAILED"
                                      ? "red"
                                      : queueData.fax_status === "COMPLETED"
                                      ? "green"
                                      : queueData.fax_status === "PENDING"
                                      ? "orange"
                                      : "gray",
                                  fontWeight: 500,
                                }}
                              >
                                {queueData.fax_status}
                              </span>
                            </td>

                            <td
                              className="ellipsis"
                              title={moment(queueData.msg_requestTime).format(
                                "DD MMM YYYY, hh:mm A"
                              )}
                            >
                              {moment(queueData.msg_requestTime).format(
                                "DD MMM YYYY, hh:mm A"
                              )}
                            </td>

                            <td>
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                  setSelectedQueue(queueData);
                                  setModalOpen(true);
                                }}
                                type="button"
                              >
                                Detail
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    !queuesDataLoader &&
                    filteredData &&
                    filteredData.length === 0 && (
                      <EmptyResult
                        title={"No Queues Data Found"}
                        description={`You currently have no queues.`}
                      />
                    )
                  )}
                </div>

                {modalOpen && selectedQueue && (
                  <div
                    className="modal-backdrop"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0,0,0,0.5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1050,
                    }}
                    onClick={() => setModalOpen(false)}
                  >
                    <div
                      className="card"
                      style={{ width: "90%", maxWidth: 900 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="card-header d-flex justify-content-between">
                        <h5 className="mb-0">Queue Details</h5>
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => setModalOpen(false)}
                        />
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {Object.entries(selectedQueue).map(([k, v]) => (
                            <div className="col-md-6 mb-2" key={k}>
                              <strong style={{ textTransform: "capitalize" }}>
                                {k.replace(/_/g, " ")}
                              </strong>
                              <div style={{ wordBreak: "break-word" }}>
                                {k.toLowerCase().includes("time")
                                  ? moment(v).format("DD MMM YYYY, hh:mm A")
                                  : String(v)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="card-footer text-end">
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={() => setModalOpen(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* end card */}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  queuesDataLoader: state.sentFax.queuesDataLoader,
  queuesData: state.sentFax.queuesData,
});

export default connect(mapStateToProps, {
  actionGetFaxQueues,
})(Queues);
